import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CollectionSetBoard from '../Collection/CollectionSetBoard';
import CollectionBoard from '../Collection/CollectionBoard';
import MarkdownRenderer from '../Markdown/MarkdownRenderer';
import './PublicView.css';

const API_BASE = 'https://2088.xn--p1ai/api';

const PublicView = ({ publicUrl }) => {
    const [site, setSite] = useState(null);
    const [channels, setChannels] = useState([]);
    const [activeChannel, setActiveChannel] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 1. Загружаем сайт и каналы
    useEffect(() => {
        const loadSite = async () => {
            try {
                const siteRes = await axios.get(`${API_BASE}/public/site`, {
                    params: { publicUrl }
                });
                setSite(siteRes.data);

                const channelsRes = await axios.get(
                    `${API_BASE}/public/site/${siteRes.data.id}/channels`
                );
                setChannels(channelsRes.data);

                if (channelsRes.data.length > 0) {
                    setActiveChannel(channelsRes.data[0]);
                }
                setLoading(false);
            } catch (err) {
                console.error('❌ Ошибка загрузки сайта:', err);
                setError(
                    err.response?.status === 404
                        ? 'Сайт не найден или не является публичным'
                        : 'Ошибка загрузки'
                );
                setLoading(false);
            }
        };
        loadSite();
    }, [publicUrl]);

    if (loading) return <div className="public-loading">Загрузка...</div>;
    if (error) return <div className="public-error">{error}</div>;

    return (
        <div className="public-view">
            {/* Заголовок */}
            <header className="public-header">
                <div className="public-header-left">
                    {site.icon && <img src={site.icon} alt={site.name} className="public-site-icon" />}
                    <h1>{site.name}</h1>
                    <span className="public-badge">🌐 Публичный доступ</span>
                </div>
                <a href="/login" className="login-btn">Войти</a>
            </header>

            <div className="public-layout">
                {/* Каналы */}
                <aside className="public-channels">
                    <h3>Каналы</h3>
                    {channels.map(ch => (
                        <div
                            key={ch.id}
                            className={`public-channel-item ${activeChannel?.id === ch.id ? 'active' : ''}`}
                            onClick={() => setActiveChannel(ch)}
                        >
                            <span className="channel-hash">#</span>
                            <span>{ch.name}</span>
                        </div>
                    ))}
                </aside>

                {/* Контент канала */}
                <main className="public-content">
                    {activeChannel?.type === 'collectionset' ? (
                        <CollectionSetBoard
                            channel={activeChannel}
                            isOwner={false}
                            isReadOnly={true}
                        />
                    ) : activeChannel?.type === 'collection' ? (
                        <CollectionBoard
                            channel={activeChannel}
                            collectionSetId={activeChannel.collectionSetId}
                            isOwner={false}
                            isReadOnly={true}
                        />
                    ) : (
                        <PublicMessages channel={activeChannel} />
                    )}
                </main>
            </div>

            {/* Подвал */}
            
            <footer className="public-footer">
                <div className="public-footer-message">
                    🔒 Только для чтения. <a href="/login">Войдите</a>, чтобы писать.
                </div>
            </footer>
            
        </div>
    );
};

// Компонент для обычных текстовых сообщений
const PublicMessages = ({ channel }) => {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if (!channel?.id) return;

        const loadMessages = () => {
            axios.get(`${API_BASE}/public/channel/${channel.id}/messages`, {
                params: { limit: 50 }
            })
            .then(res => setMessages(res.data))
            .catch(err => console.error(err));
        };

        loadMessages();
        // Polling каждые 10 секунд (без SignalR)
        const interval = setInterval(loadMessages, 10000);
        return () => clearInterval(interval);
    }, [channel?.id]);

    return (
        <>
            <div className="public-channel-header">
                <span className="channel-hash">#</span>
                <h2>{channel?.name}</h2>
            </div>
            <div className="public-messages-list">
                {messages.length === 0 ? (
                    <div className="public-empty">Нет сообщений</div>
                ) : (
                    messages.map(msg => (
                        <div key={msg.id} className="public-message">
                            <div className="public-message-avatar">
                                {msg.authorAvatar
                                    ? <img src={msg.authorAvatar} alt={msg.authorName} />
                                    : <div className="avatar-letter">{msg.authorName?.charAt(0) || '?'}</div>}
                            </div>
                            <div className="public-message-content">
                                <div className="public-message-header">
                                    <strong>{msg.authorName}</strong>
                                    <span>{new Date(msg.createdAt).toLocaleString('ru-RU')}</span>
                                </div>
                                <MarkdownRenderer content={msg.content} />
                            </div>
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default PublicView;